module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alexander Key\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alexander Key (1904–1979) started out as an illustrator before he began writing science fiction novels for young readers. He has published many titles, including "), _c('I', [_vm._v("Sprockets: A Little Robot")]), _vm._v(","), _c('I', [_vm._v(" Mystery of the Sassafras Chair")]), _vm._v(", and "), _c('I', [_vm._v("The Forgotten Door")]), _vm._v(", winner of the Lewis Carroll Shelf Award"), _c('I', [_vm._v(". ")]), _vm._v("Key’s novel "), _c('I', [_vm._v("Escape to Witch Mountain")]), _vm._v(" was adapted for film in 1975, 1995, and 2009. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6dTl9h/tc-custom/9781497652552.jpg?1705839757722",
      "alt": "This image is the cover for the book Mystery of the Sassafras Chair"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mystery of the Sassafras Chair\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In the Carolina hills, a friend reaches out from beyond the grave")]), _c('br'), _c('br'), _vm._v("His parents dead, Timor is brought to America to live with his uncle in rural Appalachia. Although half-American, this shy young boy has never lived outside of Indonesia and finds it hard to adjust to life in the mountains. His only friend is Wiley Pendergrass, a mysterious old hermit who sees magic in discarded wood. For Timor, Wiley makes a ladder-back chair out of sassafras—a hard yellow wood with powers that will change Timor’s life forever."), _c('br'), _vm._v(" "), _c('br'), _vm._v("Accused by a local gem collector of stealing a precious box, Wiley pushes his ancient pickup as hard as he can to escape the police. Screaming around a hairpin mountain turn, he loses control and sails off the side of a cliff. Soon after, the chair begins speaking to Timor in Wiley’s voice. His friend may be gone, but with the help of a little Appalachian magic, Timor has a chance to clear Wiley’s name."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0